import React from 'react';
import { Typography, Row, Col, Space, Alert, Button } from 'antd';
import { Screen } from '../../components/UI/Screen.component';
import { Container } from '../../components/UI/Container.component';
import { Section } from '../../components/UI/Section.component';
import { ChangePasswordForm } from '../../components/Dashboard/account/ChangePasswordForm.component';

const { Title, Text } = Typography;

export const PasswordExpiredScreen = ({account, ...props}) => {

    return (
        <>
            <Screen id='password-expired-screen'>
                <Container>
                    <Row justify='center'>
                        <Col>
                            <Section style={{maxWidth: 450, paddingBottom: 50}}>
                                <Row justify='center'>
                                    <Space direction='vertical' align='center' size='large'>
                                        <span>
                                            <img src='/img/logoL' alt="AvaLAN Networks logo" style={{pointerEvents: 'none', width: 250, margin: '0 auto'}}/>
                                        </span>
                                        <Title level={3} style={{color: 'var(--primary-color)',}}>Welcome back, {account?.firstName || account?.username}!</Title>
                                    </Space>
                                </Row>
                                <Space direction='vertical' size='large'>
                                    <Alert
                                        description={<Text type='danger'>Your password has expired.</Text>}
                                        type="error"
                                        style={{color: 'var(--error-color)', borderLeft: '6px solid var(--error-color)', padding: 10}}
                                        />
                                    <p>We've noticed you haven't changed your password in the past 90 days. For your account security, please set a new password.</p>
                                    <ChangePasswordForm account={account} showTitle={false} backToLogin style={{marginBottom: -30}}/>
                                </Space>
                            </Section>
                        </Col>
                    </Row>
                </Container>
            </Screen>
        </>
    )

}